import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getHoldingList,
	addNewHolding,
	updateHolding,
	deleteHolding,
	getHolding,
} from '../holding/thunk';

export const initialState = {
	itemHoldingList: [],
	itemHoldingDetail: null,
	isHoldingLoading: false,
	isHoldingSuccess: false,

	holdingList: [],
	holdingListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const HoldingSlice = createSlice({
	name: 'Holdings',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getHolding.fulfilled, (state, action) => {
			state.isHoldingLoading = false;
			state.isHoldingSuccess = true;
			state.itemHoldingDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getHolding.pending, state => {
			state.isHoldingLoading = true;
			state.isHoldingSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getHolding.rejected, (state, action) => {
			state.isHoldingLoading = false;
			state.isHoldingSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getHoldingList.pending, state => {
			state.isHoldingSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getHoldingList.fulfilled, (state, action) => {
			state.itemHoldingList = action.payload;
			state.holdingList = action.payload;
			state.isLoadingList = false;
			state.isHoldingSuccess = true;

			let holdingListSelect = [];
			action.payload.map(item =>
				holdingListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.holdingListSelect = holdingListSelect;
		});
		builder.addCase(getHoldingList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isHoldingSuccess = true;
		});
		builder.addCase(addNewHolding.fulfilled, (state, action) => {
			state.itemHoldingList.push(action.payload);
			state.holdingList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewHolding.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewHolding.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateHolding.fulfilled, (state, action) => {
			state.itemHoldingList = state.itemHoldingList.map(holding =>
				holding.holdingname === action.payload.old_holding
					? { ...holding, ...action.payload.updated_holding }
					: holding
			);
			state.holdingList = state.holdingList.map(holding =>
				holding._id.toString() === action.payload._id.toString()
					? { ...holding, ...action.payload }
					: holding
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateHolding.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateHolding.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteHolding.fulfilled, (state, action) => {
			state.itemHoldingList = current(state.itemHoldingList).filter(
				item => item._id !== action.payload._id
			);
			state.holdingList = current(state.holdingList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteHolding.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteHolding.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = HoldingSlice.actions;

export default HoldingSlice.reducer;
